import React from "react";
import { observer } from "mobx-react";
import { HorizontalSeparator } from "../../../settingsForms/separators/horizontalSeparator/horizontalSeparator";
import { useStore } from "../../../../../models";
import { VerticalSeparator } from "../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { ExistingAdviserForm } from "../../types";
import { AdviserLimitsSummary } from "../adviserLimitsSummary/adviserLimitsSummary";
import { AdviserNameSummary } from "../adviserNameSummary/adviserNameSummary";
import { AdviserRoleSummary } from "../adviserRoleSummary/adviserRoleSummary";
import { AdviserTagsSummary } from "../adviserTagsSummary/adviserTagsSummary";
import styles from "./agentBox.css";
import { AdviserAgentGroupsSummary } from "../adviserAgentGroupsSummary/adviserAgentGroupsSummary";

interface Props {
  form: ExistingAdviserForm;
  orgAutoAssignedLimit?: number;
  isExpanded: boolean;
}
export const AgentBox = observer(({ form, orgAutoAssignedLimit, isExpanded }: Props) => {
  const { tagsStore, roleStore, tagGroupsStore, agentGroupStore } = useStore();
  const agentGroupNames: string[] = agentGroupStore
    .getByIds(form.$.agentGroupIds.$)
    .map((agentGroup) => agentGroup.name);
  const {
    email,
    firstName,
    lastName,
    avatarToken,
    roleId,
    tagIds,
    tagGroupIds,
    presence,
    autoAssignedLimit
  } = form.$;

  const tags = tagsStore.getFromIds(tagIds.$);
  const tagGroups = tagGroupsStore.getFromIds(tagGroupIds.$);
  const role = roleStore.getRoleById(roleId.$);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <AdviserNameSummary
          adviser={{
            email: email.$,
            firstName: firstName.$,
            lastName: lastName.$,
            avatarToken: avatarToken.$,
            presence: presence.$
          }}
        />
        <VerticalSeparator />
        <AdviserTagsSummary tags={tags} tagGroups={tagGroups} />
        <VerticalSeparator />
        {role && <AdviserRoleSummary role={role} />}
        {(autoAssignedLimit.$ !== undefined || orgAutoAssignedLimit !== undefined) && (
          <>
            <VerticalSeparator />
            <AdviserLimitsSummary
              adviser={{ autoAssignedLimit: autoAssignedLimit.$ ?? orgAutoAssignedLimit }}
            />
          </>
        )}
      </div>
      {isExpanded && (
        <>
          <HorizontalSeparator style="margin-around" />
          <AdviserAgentGroupsSummary agentGroups={agentGroupNames} />
        </>
      )}
    </div>
  );
});
